<template>
  <div>
    <page-title>News Categories</page-title>

    <section-block>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button
          :primary="true"
          @click="$router.push({ name: 'AdminNewsCategoryCreate' })"
          >Create Category</base-button
        >
      </template>

      <vuetable
        class="c-data-table"
        :api-mode="false"
        :fields="table.fields"
        :data="categories"
        @vuetable:row-clicked="onRowClicked"
      >
        <template slot="date-created" slot-scope="props">
          <base-datetime :date="props.rowData.created_time"></base-datetime>
        </template>

        <template slot="category-actions" slot-scope="props">
          <category-actions
            routePath="AdminNewsCategoryEdit"
            :id="props.rowData.id"
            deleteAction="NewsCategories/delete"
          />
        </template>
      </vuetable>
    </section-block>
  </div>
</template>

<script>
import CategoryActions from '@/components/CategoryActions';

export default {
  data() {
    return {
      newsCategories: [],
      table: {
        fields: [
          {
            name: 'name',
            titleClass: 'u-ta-left',
            title: 'Category Name',
            width: '20%',
          },
          {
            name: 'description',
            titleClass: 'u-ta-left',
            title: 'Category description',
            width: '40%',
          },
          {
            name: 'date-created',
            titleClass: 'u-ta-left',
            title: 'Date Created',
            width: '20%',
          },
          {
            name: 'category-actions',
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
        ],
      },
    };
  },

  created() {
    this.$store.dispatch('NewsCategories/list');
  },
  computed: {
    CategoryError() {
      return this.$store.state.NewsCategories.errorState;
    },
    categories() {
      return this.$store.state.NewsCategories.categories;
    },
  },
  components: {
    CategoryActions,
  },
  methods: {
    onRowClicked(dataItem, event) {
      if (dataItem.event.target.localName === 'td' || dataItem.event.target.parentNode.localName === 'td') {
        this.$router.push({
          name: 'AdminNewsCategoryEdit',
          params: { id: dataItem.data.id },
        });
      }
    },
  },
};
</script>

<style scoped>
/**
 * TODO: Figure out why vuetable is doing a td within a td
 **/
td > td {
  border: 0;
  margin: 0;
  padding: 0;
  display: block;
}
</style>
